// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { injectModels } from "../../redux/injectModels";
// import { toast } from "react-toastify";
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';

// const UpdateSession = ({props,id,modelOpen}) => {
//   const navigate = useNavigate();
// //   const { session_id } = useParams();
// console.log("id ===", id,modelOpen);

//   const [error, setError] = useState("");
//   const [sessionName, setSessionName] = useState("");
//   const [jobProfile, setJobProfile] = useState("");
//   const [company, setCompany] = useState("");
//   const [interviewer, setInterviewer] = useState("");
//   const [interviewee, setInterviewee] = useState("");
//   const [topic, setTopic] = useState("");
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);

//   const [sessionNameError, setSessionNameError] = useState("");
//   const [jobProfileError, setJobProfileError] = useState("");
//   const [companyError, setCompanyError] = useState("");
//   const [interviewerError, setInterviewerError] = useState("");
//   const [intervieweeError, setIntervieweeError] = useState("");
//   const [topicError, setTopicError] = useState("");

//   useEffect(() => {
//     getViewSession();
//   }, []);

//   const getViewSession = async () => {
//     props.application.setLoading(true);
//     try {
//       const res = await props.admin.viewSession(id);
//       if (res.user) {
//         setSessionName(res && res.user.title);
//         setJobProfile(res && res.user.job_profile);
//         setInterviewer(res && res.user.client);
//         setInterviewee(res && res.user.user);
//         setTopic(res && res.user.topic);
//         setCompany(res && res.user.company_name);
//         props.application.setLoading(false);
//       } else {
//         props.application.setLoading(false);
//       }
//     } catch (error) {
//       props.application.setLoading(false);
//     }
//   };

//   const handleSessionName = (e) => {
//     const val = e.target.value;
//     if (val === "") {
//       setSessionNameError("Session Name is required!");
//     } else {
//       setSessionNameError("");
//     }
//     setSessionName(val);
//   };

//   const handleJobProfile = (e) => {
//     const val = e.target.value;
//     if (val === "") {
//       setJobProfileError("Job Profile is required!");
//     } else {
//       setJobProfileError("");
//     }
//     setJobProfile(val);
//   };
//   const handleCompany = (e) => {
//     const val = e.target.value;
//     if (val === "") {
//       setCompanyError("Company name is required!");
//     } else {
//       setCompanyError("");
//     }
//     setCompany(val);
//   };

//   const handleInterviewer = (e) => {
//     const val = e.target.value;
//     if (val === "") {
//       setInterviewerError("Interviewer Name is required!");
//     } else {
//       setInterviewerError("");
//     }
//     setInterviewer(val);
//   };

//   const handleInterviewee = (e) => {
//     const val = e.target.value;
//     if (val === "") {
//       setIntervieweeError("Interviewee Name is required!");
//     } else {
//       setIntervieweeError("");
//     }
//     setInterviewee(val);
//   };

//   const handleTopic = (e) => {
//     const val = e.target.value;
//     if (val === "") {
//       setTopicError("Topic Name is required!");
//     } else {
//       setTopicError("");
//     }
//     setTopic(val);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     let error = true;

//     if (sessionName.trim() === "") {
//       error = false;
//       setSessionNameError("Session Name is required!");
//     } else {
//       setSessionNameError("");
//     }

//     if (jobProfile.trim() === "") {
//       error = false;
//       setJobProfileError("Job Profile Name is required!");
//     } else {
//       setJobProfileError("");
//     }
//     if (company.trim() === "") {
//       error = false;
//       setCompanyError("Job Profile Name is required!");
//     } else {
//       setCompanyError("");
//     }
//     if (interviewer.trim() === "") {
//       error = false;
//       setInterviewerError("Interviewer Name is required!");
//     } else {
//       setInterviewerError("");
//     }
//     if (interviewee.trim() === "") {
//       error = false;
//       setIntervieweeError("Interviewee Name is required!");
//     } else {
//       setIntervieweeError("");
//     }
//     if (topic.trim() === "") {
//       error = false;
//       setTopicError("Topic Name is required!");
//     } else {
//       setTopicError("");
//     }

//     if (!error) {
//       setError("Please fill all fields!");
//       return;
//     } else {
//       setError("");
//       try {
//         props.application.setLoading(true);
//         const data = {
//           title: sessionName,
//           job_profile: jobProfile,
//           company_name: company,
//           user: interviewee,
//           client: interviewer,
//           topic: topic,
//         };
//         const res = await props.admin.updateSession(data, id);

//         if (res.data.success === true) {
//           props.application.setLoading(false);
//           toast.dismiss();
//           toast.success(res.data.message, {
//             position: toast.POSITION.TOP_CENTER,
//           });
//           navigate("/session");
//         } else {
//           toast.dismiss();
//           toast.error(res.data.message, {
//             position: toast.POSITION.TOP_CENTER,
//           });
//           props.application.setLoading(false);
//         }
//       } catch (error) {
//         console.log(error);
//         props.application.setLoading(false);
//         toast.dismiss();
//         toast.error("Something went wrong!", {
//           position: toast.POSITION.TOP_CENTER,
//         });
//       }
//     }
//   };

//   const handleClick = () => {
//     navigate("/session");
//   };

//   return (
//     <React.Fragment>
//     <Modal
//     show={modelOpen}
//     onHide={handleClose}
//     {...props}
//     size="lg"
//     aria-labelledby="contained-modal-title-vcenter"
//     centered
//   >
//   <Modal.Header closeButton>
//           <Modal.Title>Update Session</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//               <form onSubmit={handleSubmit}>
//                 <div style={{ marginBottom: "20px" }}>
//                   <label htmlFor="sessionName">Session Name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="sessionName"
//                     value={sessionName}
//                     onChange={handleSessionName}
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       border: "1px solid #ccc",
//                       borderRadius: "5px",
//                     }}
//                   />
//                   {sessionNameError && (
//                     <div className="text-danger">{sessionNameError}</div>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: "20px" }}>
//                   <label htmlFor="jobProfile">Job Profile</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="jobProfile"
//                     value={jobProfile}
//                     onChange={handleJobProfile}
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       border: "1px solid #ccc",
//                       borderRadius: "5px",
//                     }}
//                   />
//                   {jobProfileError && (
//                     <div className="text-danger">{jobProfileError}</div>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: "20px" }}>
//                   <label htmlFor="company">Company name</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="company"
//                     value={company}
//                     onChange={handleCompany}
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       border: "1px solid #ccc",
//                       borderRadius: "5px",
//                     }}
//                   />
//                   {companyError && (
//                     <div className="text-danger">{companyError}</div>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: "20px" }}>
//                   <label htmlFor="interviewer">Interviewer</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="interviewer"
//                     value={interviewer}
//                     onChange={handleInterviewer}
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       border: "1px solid #ccc",
//                       borderRadius: "5px",
//                     }}
//                   />
//                   {interviewerError && (
//                     <div className="text-danger">{interviewerError}</div>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: "20px" }}>
//                   <label htmlFor="interviewee">Interviewee</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="interviewee"
//                     value={interviewee}
//                     onChange={handleInterviewee}
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       border: "1px solid #ccc",
//                       borderRadius: "5px",
//                     }}
//                   />
//                   {intervieweeError && (
//                     <div className="text-danger">{intervieweeError}</div>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: "20px" }}>
//                   <label htmlFor="topic">Topic</label>
//                   <select
//                     className="form-select"
//                     value={topic}
//                     onChange={handleTopic}
//                   >
//                     <option value="">Select Topic</option>
//                     <option value="Insurance">Insurance</option>
//                     <option value="Purchase Coordinator">
//                       Purchase Coordinator
//                     </option>
//                     <option value="Secondary Sales Coordinator">
//                       Secondary Sales Coordinator
//                     </option>
//                     <option value="Vendor cost subsheet">
//                       Vendor cost subsheet
//                     </option>
//                     <option value="Services FMS Sheet">
//                       Services FMS Sheet
//                     </option>
//                   </select>
//                   /*{" "}
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="topic"
//                     value={topic}
//                     onChange={handleTopic}
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       border: "1px solid #ccc",
//                       borderRadius: "5px",
//                     }}
//                   />
//                   */}
//                   {topicError && (
//                     <div className="text-danger">{topicError}</div>
//                   )}
//                 </div>
//                 {error && (
//                   <div className="col-xs-12 col-md-12 col-lg-12">
//                     <div className="alert alert-danger">{error}</div>
//                   </div>
//                 )}
//               </form>
//               </Modal.Body>
//               <Modal.Footer>
//               <div
//               style={{
//                 display: "flex",
//                 justifyContent: "end",
//                 alignItems: "center",
//               }}
//             >
//               <button
//                 type="button"
//                 className="btn btn-secondary "
//                 onClick={handleClick}
//               >
//                 Back
//               </button>
//               <button type="submit" className="btn btn-primary ">
//                 Update Session
//               </button>
//             </div>
//             </Modal.Footer>
//       </Modal>
//     </React.Fragment>
// )

// };

// export default injectModels(["admin", "application"])(UpdateSession);

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { injectModels } from "../../redux/injectModels";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";

const UpdateSession = ({ props, id, isOpen, closeModal }) => {
  const navigate = useNavigate();

  const [sessionName, setSessionName] = useState("");
  const [jobProfile, setJobProfile] = useState("");
  const [company, setCompany] = useState("");
  const [interviewer, setInterviewer] = useState("");
  const [interviewee, setInterviewee] = useState("");
  const [topic, setTopic] = useState("");
  const [error, setError] = useState("");

  const [formErrors, setFormErrors] = useState({
    sessionNameError: "",
    jobProfileError: "",
    companyError: "",
    interviewerError: "",
    intervieweeError: "",
    topicError: "",
  });

  useEffect(() => {
    getViewSession();
  }, [id, isOpen]);

  const getViewSession = async () => {
    props.application.setLoading(true);
    try {
      const res = await props.admin.viewSession(id);
      if (res.user) {
        setSessionName(res.user.title || "");
        setJobProfile(res.user.job_profile || "");
        setCompany(res.user.company_name || "");
        setInterviewer(res.user.client || "");
        setInterviewee(res.user.user || "");
        setTopic(res.user.topic || "");
      }
    } catch (error) {
      console.error(error);
    } finally {
      props.application.setLoading(false);
    }
  };

  const handleClose = () => {
    closeModal();
    navigate("/session");
  };

  const validateForm = () => {
    const errors = {};
    if (!sessionName.trim())
      errors.sessionNameError = "Session Name is required!";
    if (!jobProfile.trim()) errors.jobProfileError = "Job Profile is required!";
    if (!company.trim()) errors.companyError = "Company name is required!";
    if (!interviewer.trim())
      errors.interviewerError = "Interviewer Name is required!";
    if (!interviewee.trim())
      errors.intervieweeError = "Interviewee Name is required!";
    if (!topic.trim()) errors.topicError = "Topic is required!";
    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setError("Please fill all fields!");
      return;
    }

    setError("");
    const data = {
      title: sessionName,
      job_profile: jobProfile,
      company_name: company,
      user: interviewee,
      client: interviewer,
      topic,
    };

    try {
      props.application.setLoading(true);
      const res = await props.admin.updateSession(data, id);
      if (res.data.success) {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        handleClose();
      } else {
        toast.error(res.data.message, { position: toast.POSITION.TOP_CENTER });
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      props.application.setLoading(false);
    }
  };

  return (
    <Modal
      show={isOpen}
      onHide={closeModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Update Session</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="row g-3 p-2" onSubmit={handleSubmit}>
          {[
            {
              label: "Session Name",
              value: sessionName,
              setter: setSessionName,
              error: formErrors.sessionNameError,     
            },
            {
              label: "Job Profile",
              value: jobProfile,
              setter: setJobProfile,
              error: formErrors.jobProfileError,
              limit:250
            },
            {
              label: "Company Name",
              value: company,
              setter: setCompany,
              error: formErrors.companyError,
              limit:250
            },
            {
              label: "Interviewer",
              value: interviewer,
              setter: setInterviewer,
              error: formErrors.interviewerError,
              limit:240
            },
            {
              label: "Interviewee",
              value: interviewee,
              setter: setInterviewee,
              error: formErrors.intervieweeError,
              limit:240
            },
          ].map(({ label, value, setter, error ,limit}, index) => (
            <div className="col-md-6" key={index}>
              <label htmlFor="" className="form-label">
                {label}
              </label>
              <input
                type="text"
                className="form-control"
                value={value}
                onChange={(e) => setter(e.target.value)}
                maxLength={limit}
              />

              {error && <div className="text-danger">{error}</div>}
            </div>
          ))}

          <div className="col-md-6">
            <label htmlFor="" className="form-label">
              Topic
            </label>
            <select
              className="form-select"
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
            >
              <option value="">Select Topic</option>
              <option value="Insurance">Insurance</option>
              <option value="Purchase Coordinator">Purchase Coordinator</option>
              <option value="Secondary Sales Coordinator">
                Secondary Sales Coordinator
              </option>
              <option value="Vendor cost subsheet">Vendor cost subsheet</option>
              <option value="Services FMS Sheet">Services FMS Sheet</option>
            </select>
            {formErrors.topicError && (
              <div className="text-danger">{formErrors.topicError}</div>
            )}
          </div>
          {error && <div className="alert alert-danger">{error}</div>}

          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <button className="btn btn-secondary" onClick={closeModal}>
              Back
            </button>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Update Session
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default injectModels(["admin", "application"])(UpdateSession);
